<template>
    <b-container fluid>
        <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('sales_distribution_admin.sales_dashboard') }}</h4>
            </template>
            <template v-slot:body>
                <b-row>
                    <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                        <b-form-group
                            class="row"
                            label-cols-sm="4"
                            :label="$t('sales_distribution_admin.sales_center')"
                            label-for="sales_center_id"
                            >
                            <b-form-select
                            plain
                            v-model="search.sales_center_id"
                            :options="salesCenterList"
                            id="sales_center_id"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                        <b-form-group
                            class="row"
                            label-cols-sm="4"
                            :label="$t('globalTrans.fiscal_year')"
                            label-for="type_id"
                            >
                            <b-form-select
                            plain
                            v-model="search.fiscal_year_id"
                            :options="fiscalYearList"
                            id="type_id"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                        <b-form-group
                            class="row"
                            label-cols-sm="4"
                            :label="$t('retailerManagement.month')"
                            label-for="type_id"
                            >
                            <b-form-select
                            plain
                            v-model="search.month"
                            :options="monthList"
                            id="type_id"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                        <b-form-group
                            class="row"
                            label-cols-sm="4"
                            :label="$t('sales_distribution_admin.from_date')"
                            label-for="from_date"
                        >
                            <b-form-input class="form-control"
                                v-model="search.from_date"
                                placeholder="Select From Date"
                                id="from_date"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                        <b-form-group
                            class="row"
                            label-cols-sm="4"
                            :label="$t('sales_distribution_admin.to_date')"
                            label-for="to_date"
                        >
                            <b-form-input class="form-control"
                                v-model="search.to_date"
                                placeholder="Select To Date"
                                id="to_date"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col xs="4" sm="4" md="4" lg="4" xl="4">
                        <b-form-group
                            label-cols-sm="5"
                        >
                            <template v-slot:label>
                               <span class="text-black"> {{$t('sales_distribution_admin.category')}}</span>
                            </template>
                            <b-row>
                                <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                                    <b-form-radio v-model="result_category_selected" name="result_category" value="sales"> {{ $t('sales_center.sales') }}</b-form-radio>
                                </b-col>
                                <b-col xs="6" sm="6" md="6" lg="6" xl="6">
                                    <b-form-radio v-model="result_category_selected" name="result_category" value="order"> {{ $t('sales_distribution_admin.order') }}</b-form-radio>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="text-right">
                        <b-button type="button" @click="searchData" variant="primary">{{ $t('globalTrans.search')}}</b-button>
                    </b-col>
                </b-row>
            </template>
        </iq-card>
        <b-row v-show="result_category_selected === 'sales'">
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('sales_distribution_admin.salse') + ' ' + $t('globalTrans.list') }}</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loadingState">
                            <b-row>
                                <b-col md="12" class="table-responsive">
                                    <b-table thead-class="bg-primary" bordered hover :items="dataList" :fields="sales_columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                                        <template v-slot:cell(index)="data">
                                            {{ $n(data.index + pagination.slOffset) }}
                                        </template>
                                        <template v-slot:cell(product_name)="data">
                                            {{ getProductName(data.item) }}
                                        </template>
                                        <template v-slot:cell(product_unit)="data">
                                            <span v-for="(item, idx) in getUnitName(data.item)" :key="idx">
                                                <div>{{ item }}</div>
                                            </span>
                                        </template>
                                        <template v-slot:cell(product_qty)="data">
                                            <span v-for="(item, idx) in getSales(data.item)" :key="idx">
                                                <div>{{ $n(item) }}</div>
                                            </span>
                                        </template>
                                        <template v-slot:cell(unit_price)="data">
                                            <span v-for="(item, idx) in getUnitPrice(data.item)" :key="idx">
                                                <div>{{ $n(item) }}</div>
                                            </span>
                                        </template>
                                        <template v-slot:cell(total_price)="data">
                                            <span v-for="(item, idx) in getTotalPrice(data.item)" :key="idx">
                                                <div>{{ $n(item) }}</div>
                                            </span>
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="pagination.currentPage"
                                        :per-page="pagination.perPage"
                                        :total-rows="pagination.totalRows"
                                        @input="searchData"
                                        />
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
        <b-row v-show="result_category_selected === 'order'">
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('sales_distribution_admin.order') + ' ' + $t('globalTrans.list') }}</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loadingState">
                            <b-row>
                                <b-col md="12" class="table-responsive">
                                    <b-table thead-class="bg-primary" bordered hover :items="orderList" :fields="order_columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                                        <template v-slot:cell(index)="data">
                                            {{ $n(data.index + pagination.slOffset) }}
                                        </template>
                                        <template v-slot:cell(dealer_retailer_name)="data">
                                            {{ getName(data.item) }}
                                        </template>
                                        <template v-slot:cell(total_amount)="data">
                                            {{ $n(getAmount(data.item)) }}
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="pagination.currentPage"
                                        :per-page="pagination.perPage"
                                        :total-rows="pagination.totalRows"
                                        @input="searchData"
                                        />
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import RestApi, { productionServiceBaseUrl, commonServiceBaseUrl } from '@/config/api_config'
import { fiscalYearData, scsalesReportApi, scorderReportApi } from '../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'
import flatpickr from 'flatpickr'
import { mapGetters } from 'vuex'

export default {
  mixins: [RouteBasedList],
  data () {
    return {
      search: {
        sales_center_id: 0,
        month: 0,
        from_date: '',
        to_date: '',
        fis_start_date: '',
        fis_end_date: '',
        fiscal_year_id: 0
      },
      result_category_selected: 'sales',
      rows: [],
      dataList: [],
      orderList: []
    }
  },
  created () {
    this.loadData()
  },
  computed: {
    salesCenterList: function () {
        return this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0).sort((a, b) => b.value - a.value)
    },
    monthList () {
      const objectData = this.$store.state.commonObj.monthList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    allProductList: function () {
      return this.productCommonObj.productList.filter(item => item.status === 1 && item.type_id === 2)
    },
    dealerRetailerList: function () {
        return this.productCommonObj.dealerRetailerList
    },
    ...mapGetters({
        productCommonObj: 'ProductionService/commonObj'
    }),
    sales_columns () {
      const labels = [
            { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.pro_name'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.unit'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.quantity'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.unit_price'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.total_price'), class: 'text-center' }
        ]

        let keys = []

        if (this.$i18n.locale === 'bn') {
            keys = [
                { key: 'index' },
                { key: 'product_name' },
                { key: 'product_unit' },
                { key: 'product_qty' },
                { key: 'unit_price' },
                { key: 'total_price' }
            ]
        } else {
            keys = [
                { key: 'index' },
                { key: 'product_name' },
                { key: 'product_unit' },
                { key: 'product_qty' },
                { key: 'unit_price' },
                { key: 'total_price' }
            ]
        }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    order_columns () {
      const labels = [
            { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.dealer_retailer_name'), class: 'text-left' },
            { label: this.$t('sales_distribution_admin.total_amount'), class: 'text-left' }
        ]

        let keys = []

        if (this.$i18n.locale === 'bn') {
            keys = [
                { key: 'index' },
                { key: 'dealer_retailer_name' },
                { key: 'total_amount' }
            ]
        } else {
            keys = [
                { key: 'index' },
                { key: 'dealer_retailer_name' },
                { key: 'total_amount' }
            ]
        }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    }
  },
  watch: {
    loadingState: function (newVal, oldVal) {
      if (newVal) {
        this.loadData()
      }
    },
    'search.fiscal_year_id': function (newVal) {
      RestApi.getData(commonServiceBaseUrl, `${fiscalYearData}/${newVal}`).then(response => {
        this.search.fis_start_date = response.data.start_date
        this.search.fis_end_date = response.data.end_date
      })
    }
  },
  mounted () {
        flatpickr('#to_date', {})
        flatpickr('#from_date', {})
  },
  methods: {
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      if (this.result_category_selected === 'sales') {
        RestApi.getData(productionServiceBaseUrl, scsalesReportApi, params).then(response => {
            if (response.success) {
                this.dataList = response.data
            }
        })
      } else {
        RestApi.getData(productionServiceBaseUrl, scorderReportApi, params).then(response => {
            if (response.success) {
                this.orderList = response.data
            }
        })
      }
      this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
    },
    getName (retData) {
      let category = ''
      Object.keys(retData).forEach((value) => {
        const catId = parseInt(value)
        const catObj = this.dealerRetailerList.find(item => item.value === catId)
        if (catObj !== undefined) {
          this.$i18n.locale === 'bn' ? category = catObj.text_bn : category = catObj.text_en
        } else {
          category = ''
        }
      })
      return category
    },
    getAmount (retData) {
      let category = ''
      Object.entries(retData).forEach(([key, value]) => {
          category = value
      })
      return category
    },
    getProductName (stockData) {
      let category = ''
      Object.keys(stockData).forEach((value) => {
        const catId = parseInt(value)
        const catObj = this.allProductList.find(item => item.value === catId)
        if (this.$i18n.locale === 'bn') {
          category = catObj.text_bn
        } else {
          category = catObj.text_en
        }
      })
      return category
    },
    getUnitName (prodData) {
      const unitName = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.keys(value).forEach((unvalue) => {
          const unitId = parseInt(unvalue)
          const unit = this.productCommonObj.unitInfoList.find(item => item.value === unitId)
          if (this.$i18n.locale === 'bn') {
            unitName.push(unit.text_bn)
          } else {
            unitName.push(unit.text_en)
          }
        })
      })
      return unitName
    },
    getSales (prodData) {
      const CurrentStock = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, kvalue]) => {
          CurrentStock.push(kvalue.sales_quantity)
        })
      })
      return CurrentStock
    },
    getUnitPrice (prodData) {
      const CurrentStock = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, kvalue]) => {
          CurrentStock.push(kvalue.unit_price)
        })
      })
      return CurrentStock
    },
    getTotalPrice (prodData) {
      const CurrentStock = []
      Object.entries(prodData).forEach(([key, value]) => {
        Object.entries(value).forEach(([key, kvalue]) => {
          const total = kvalue.unit_price * kvalue.sales_quantity
          CurrentStock.push(total)
        })
      })
      return CurrentStock
    }
  }
}
</script>
